function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 120 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M42.18 17.671a5.666 5.666 0 0 1-2.405 2.571l-.025.014a5.673 5.673 0 0 1-8.37-4.986 5.673 5.673 0 0 1 8.37-4.986V9.87h2.43v7.801Zm0 0v3.269h-2.43v-.684a5.645 5.645 0 0 0 2.43-2.585Zm-2.437-4.627.007.009c.43.502.515 3.826.012 4.42l-.012.014a3.438 3.438 0 0 1-2.7 1.293 3.512 3.512 0 0 1-3.51-3.51 3.512 3.512 0 0 1 3.51-3.51c1.088 0 2.061.496 2.693 1.284ZM44.612 17.671a5.666 5.666 0 0 0 2.405 2.571l.025.014a5.673 5.673 0 0 0 8.37-4.986 5.673 5.673 0 0 0-8.37-4.986V9.87h-2.43v7.801Zm0 0v7.589h2.43v-5.004a5.634 5.634 0 0 1-2.43-2.585Zm2.437-4.627-.007.009c-.511.596-.516 3.826-.012 4.42l.012.014a3.438 3.438 0 0 0 2.7 1.293 3.512 3.512 0 0 0 3.51-3.51 3.512 3.512 0 0 0-3.51-3.51 3.438 3.438 0 0 0-2.693 1.284ZM56.754 17.671a5.666 5.666 0 0 0 2.405 2.571l.025.014a5.673 5.673 0 0 0 8.37-4.986 5.673 5.673 0 0 0-8.37-4.986V9.87h-2.43v7.801Zm0 0v7.589h2.43v-5.004a5.645 5.645 0 0 1-2.43-2.585Zm2.437-4.627-.007.009c-.511.596-.515 3.826-.012 4.42l.012.014a3.44 3.44 0 0 0 2.7 1.293 3.512 3.512 0 0 0 3.51-3.51 3.512 3.512 0 0 0-3.51-3.51 3.438 3.438 0 0 0-2.693 1.284ZM69.18 9.87h2.43v11.07h-2.43z",
    style: {
      fill: "#3b3b3b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.395,
    cy: 5.955,
    r: 1.215,
    style: {
      fill: "#3b3b3b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.948,
    cy: 5.955,
    r: 1.215,
    style: {
      fill: "#3b3b3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.73 9.87h2.43v11.07h-2.43zM76.74 10.316a4.974 4.974 0 0 0-2.43 4.279c0 1.818.973 3.411 2.43 4.279v2.066h-2.43V9.87h2.43v.446ZM106.44 10.316a4.974 4.974 0 0 0-2.43 4.279c0 1.818.973 3.411 2.43 4.279v2.066h-2.43V9.87h2.43v.446Z",
    style: {
      fill: "#3b3b3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.74 13.405v2.38a2.7 2.7 0 0 1-.27-1.19c0-.426.094-.83.27-1.19ZM106.44 13.405v2.38a2.7 2.7 0 0 1-.27-1.19c0-.426.094-.83.27-1.19ZM84.3 14.595v6.345h-2.43v-2.066a4.974 4.974 0 0 0 2.43-4.279ZM114 14.595v6.345h-2.43v-2.066a4.974 4.974 0 0 0 2.43-4.279ZM81.87 14.595ZM111.57 14.595ZM84.3 14.595l-.007-.135h.007v.135ZM114 14.595l-.007-.135H114v.135ZM84.3 14.595ZM114 14.595ZM76.74 10.316a4.9 4.9 0 0 1 2.565-.716 4.99 4.99 0 0 1 4.988 4.86H81.87v.135c0-1.565-1-2.835-2.565-2.835a2.817 2.817 0 0 0-2.565 1.645v-3.089ZM106.44 10.316a4.9 4.9 0 0 1 2.565-.716 4.99 4.99 0 0 1 4.988 4.86h-2.423v.135c0-1.565-1-2.835-2.565-2.835a2.817 2.817 0 0 0-2.565 1.645v-3.089Z",
    style: {
      fill: "#3b3b3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.74 10.316v3.089a2.7 2.7 0 0 0-.27 1.19c0 .426.094.83.27 1.19v3.089a4.974 4.974 0 0 1-2.43-4.279c0-1.818.973-3.411 2.43-4.279ZM106.44 10.316v3.089a2.7 2.7 0 0 0-.27 1.19c0 .426.094.83.27 1.19v3.089a4.974 4.974 0 0 1-2.43-4.279c0-1.818.973-3.411 2.43-4.279ZM84.293 14.46l.007.135a4.974 4.974 0 0 1-2.43 4.279V14.46h2.423ZM113.993 14.46l.007.135a4.974 4.974 0 0 1-2.43 4.279V14.46h2.423ZM96.72 9.6a5.673 5.673 0 0 1 5.67 5.67 5.673 5.673 0 0 1-5.67 5.67 5.673 5.673 0 0 1-5.67-5.67 5.673 5.673 0 0 1 5.67-5.67Zm0 2.16a3.512 3.512 0 0 1 3.51 3.51 3.512 3.512 0 0 1-3.51 3.51 3.512 3.512 0 0 1-3.51-3.51 3.512 3.512 0 0 1 3.51-3.51Z",
    style: {
      fill: "#3b3b3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2 7.44a2.7 2.7 0 0 0-2.7-2.7H8.681A2.68 2.68 0 0 0 6 7.421V22.56a2.7 2.7 0 0 0 2.7 2.7h10.8a2.7 2.7 0 0 0 2.7-2.7V7.44ZM14.1 20.4a1.215 1.215 0 1 1 0 2.43 1.215 1.215 0 0 1 0-2.43Zm2.295-2.16 2.063.982a.538.538 0 0 0 .772-.487V10.41a2.697 2.697 0 0 0-2.7-2.7h-4.879a2.68 2.68 0 0 0-2.681 2.681v5.149a2.697 2.697 0 0 0 2.7 2.7h4.725Z",
    style: {
      fill: "#ff5144"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7144622e448b578785cf1d28650dd2b6.svg";
export { ForwardRef as ReactComponent };